import script from "./StepDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./StepDescription.vue?vue&type=script&setup=true&lang=js"

import "./StepDescription.vue?vue&type=style&index=0&id=6c84d788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c84d788"]])

export default __exports__